// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mob_Navbar{
    position: absolute;
    top: 0;
    width: 100%;
    color: white !important;
    z-index: 30;
}
.burger{
    position: absolute;
    top:37px;
    left:15px;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    justify-content: center;
}
.burger>div{
    width: 35px;
    height:5px;
    background-color: white;
    background: white
}
.burger>:nth-child(1){
    animation: burger1 0.5s linear;
    transform: rotate(0deg);
}
@keyframes burger1 {
    0%{
        transform: rotate(45deg);
        background: white !important
    }
    100%{
        transform: rotate(0deg);
        background-color: white;
    }
}
.burger>:nth-child(2){
    animation: burger2 0.5s linear;
    transform: rotate(0deg);
}
@keyframes burger2 {
    0%{
        transform: rotate(135deg);
        background: white !important
    }
    100%{
    transform: rotate(0deg);
    background-color: white;
    }
}
.cross>:nth-child(1){
    animation: cross1 0.5s linear;
    transform: rotate(45deg);
    background: white !important
}
@keyframes cross1 {
    0%{
        transform: rotate(0deg);
        background: white !important
    }
    100%{
        transform: rotate(45deg);
        background: white
    }
}
.cross>:nth-child(2){
    animation: cross2 0.5s linear;
    transform: rotate(135deg);
    background: white !important
}
@keyframes cross2 {
    0%{
        transform: rotate(0deg);
        background: white !important
    }
    100%{
        transform: rotate(135deg);
        background: white
    }
}
.mobile_nav{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #202123;
    height: 100vh;
    width: 45%;
}
.newChat_btn{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    margin-left: 55px;
    width: 50%;
}
@media only screen and (min-width: 551px){
    .Mob_Navbar{
        display: none !important;
    }
}
@media screen and (max-width: 380px){
    .burger>div {
        width: 24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/MobileNavbar/MobileNavbar.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB;AACJ;AACA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI;QACI,wBAAwB;QACxB;IACJ;IACA;QACI,uBAAuB;QACvB,uBAAuB;IAC3B;AACJ;AACA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI;QACI,yBAAyB;QACzB;IACJ;IACA;IACA,uBAAuB;IACvB,uBAAuB;IACvB;AACJ;AACA;IACI,6BAA6B;IAC7B,wBAAwB;IACxB;AACJ;AACA;IACI;QACI,uBAAuB;QACvB;IACJ;IACA;QACI,wBAAwB;QACxB;IACJ;AACJ;AACA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB;AACJ;AACA;IACI;QACI,uBAAuB;QACvB;IACJ;IACA;QACI,yBAAyB;QACzB;IACJ;AACJ;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;IACzB,aAAa;IACb,UAAU;AACd;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,UAAU;AACd;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".Mob_Navbar{\n    position: absolute;\n    top: 0;\n    width: 100%;\n    color: white !important;\n    z-index: 30;\n}\n.burger{\n    position: absolute;\n    top:37px;\n    left:15px;\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n    justify-content: center;\n}\n.burger>div{\n    width: 35px;\n    height:5px;\n    background-color: white;\n    background: white\n}\n.burger>:nth-child(1){\n    animation: burger1 0.5s linear;\n    transform: rotate(0deg);\n}\n@keyframes burger1 {\n    0%{\n        transform: rotate(45deg);\n        background: white !important\n    }\n    100%{\n        transform: rotate(0deg);\n        background-color: white;\n    }\n}\n.burger>:nth-child(2){\n    animation: burger2 0.5s linear;\n    transform: rotate(0deg);\n}\n@keyframes burger2 {\n    0%{\n        transform: rotate(135deg);\n        background: white !important\n    }\n    100%{\n    transform: rotate(0deg);\n    background-color: white;\n    }\n}\n.cross>:nth-child(1){\n    animation: cross1 0.5s linear;\n    transform: rotate(45deg);\n    background: white !important\n}\n@keyframes cross1 {\n    0%{\n        transform: rotate(0deg);\n        background: white !important\n    }\n    100%{\n        transform: rotate(45deg);\n        background: white\n    }\n}\n.cross>:nth-child(2){\n    animation: cross2 0.5s linear;\n    transform: rotate(135deg);\n    background: white !important\n}\n@keyframes cross2 {\n    0%{\n        transform: rotate(0deg);\n        background: white !important\n    }\n    100%{\n        transform: rotate(135deg);\n        background: white\n    }\n}\n.mobile_nav{\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background-color: #202123;\n    height: 100vh;\n    width: 45%;\n}\n.newChat_btn{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0.5rem;\n    margin-left: 55px;\n    width: 50%;\n}\n@media only screen and (min-width: 551px){\n    .Mob_Navbar{\n        display: none !important;\n    }\n}\n@media screen and (max-width: 380px){\n    .burger>div {\n        width: 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
